import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_website_review_rating_config_hdr_RowClass} from '../../../dbschema';


export class WebsiteRatingConfigContainerModel extends BaseContainerModel {
  bl_cms_website_review_rating_config_hdr: bl_cms_website_review_rating_config_hdr_RowClass = new bl_cms_website_review_rating_config_hdr_RowClass();
}
